<template>
    <div class="message">
        <van-dropdown-menu>
            <van-dropdown-item get-container="body"
             v-model="message_request.statue"
             :options="option1" 
             :title-class="'left-class'"
             @change="onRefresh(true)"
             />
            <van-dropdown-item get-container="body"
             v-model="message_request.advisoryObjectCode" 
             :options="advisoryObjectCodeList" 
             :title-class="'right-class'" 
             @change="onRefresh(true)"
             />
        </van-dropdown-menu>
        <div class="list">
            
            <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
                <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    @load="onLoad"
                    
                    :error.sync="error"
                    error-text="请求失败，点击重新加载"
                >
                    <listMessage v-for="(item,index) in records" :key="index" :record="item"></listMessage>
                </van-list>
            </van-pull-refresh>
        </div>
    </div>
</template>

<script>
import { mapActions,mapGetters } from 'vuex'
import Vue from 'vue';
import { DropdownMenu, DropdownItem, PullRefresh } from 'vant';
import listMessage from '../components/listMessage.vue';

Vue.use(PullRefresh);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
export default {
    name: "InvestmentMessage",
    components: {
        listMessage
    },
    data() {
        return {
            loading: false,
            finished: false,
            refreshing: false,
            error: false,
            error_true: false,
            option1: [
                { text: '留言状态', value: '' },
                { text: '已处理', value: 10 },
                { text: '待处理', value: 1 },
            ],
            message_request:{
                statue: '',
                // startTime: "2021-09-06",
                // endTime: '',
                advisoryObjectCode: '0',
                size: 10,
                current: 0
            },
            records: [],
            advisoryObjectCodeList: [
                { text: '咨询对象', value: '0' },
            ]
        };
    },
    computed: {
        ...mapGetters('investment', ['getAdvisoryObjectList','getInvestmentMessageList','getMessageOption'])
        
    },
    created() {
        // let date = new Date();
        // let year = date.getFullYear(); // 年
        // let month = date.getMonth() + 1; // 月
        // let day = date.getDate(); // 日
        // this.message_request.endTime = year+'-'+month+'-'+day
        this.setInvestmentTitle('留言管理')
        this.setAdvisoryObjectList().then(res => {
            
            res.forEach(element => {
                if(element.value == 0){
                    element.text = '咨询对象'
                    this.$forceUpdate()
                }
            });
            this.advisoryObjectCodeList = res
        });
        
        // this.refresh()
        this.message_request.statue = this.getMessageOption.statue
        this.message_request.advisoryObjectCode = this.getMessageOption.advisoryObjectCode
    },
    watch: {},
    methods: {
        ...mapActions('investment', 
        [
            'setInvestmentTitle',
            'setAdvisoryObjectList',
            'setInvestmentMessageList',
            'setMessageOption'
        ]),
        onLoad() {
            console.log('加载下一页')
            if(!this.error_true){
                this.message_request.current++
            }
            this.refresh()
        },
        //下拉刷新时触发
        onRefresh(value) {
            if(value){
                this.setMessageOption({
                    statue: this.message_request.statue,
                    advisoryObjectCode: this.message_request.advisoryObjectCode,
                })
            }
            this.message_request.current = 1
            this.records = []
            this.refresh()
        },
        refresh(){
            this.setInvestmentMessageList(this.message_request).then(res=>{
                this.refreshing = false
                this.loading = false
                this.error_true = false
                if(res.pages > this.message_request.current){
                    this.finished = false
                }else{
                    this.finished = true
                }
                
                this.records = this.records.concat(res.records)

            }).catch(res=>{
                this.refreshing = false
                this.loading = false
                this.finished = false
                this.error=true
                this.error_true = true
            })
        }
    },
    mounted() {
        
    },
    beforeDestroy(){
    }
};
</script>

<style lang="less" scoped>
.message{
    min-height: 100%;
    font-family: PingFangSC-Regular;
    padding-bottom: 42px;
    background: #F5F6F9;

    .list{
        padding: 0 12px;
    }
    /deep/.van-dropdown-menu__bar {
        justify-content: flex-start;
    }
    /deep/.van-dropdown-menu__item{
        flex: none;
        margin-right: 20px;
    }
    
    /deep/.left-class{
        display: inline-flex;
        color: #333333;
        font-size: 14px;
        padding: 0 12px;
    }
    /deep/.left-class::before{
        content: '';
        display: inline-flex;
        color: #333333;
        font-size: 14px;
        white-space: nowrap;

    }
    /deep/.right-class{
        display: inline-flex;
        color: #333333;
        font-size: 14px;
    }
    /deep/.right-class::before{
        content: '';
        display: inline-flex;
        color: #333333;
        font-size: 14px;
        white-space: nowrap;
    }
    
    /deep/.van-ellipsis{
        white-space: nowrap;
        max-width: 150px;
    }
}
</style>